import {AxiosInstance} from "axios";
import { apiHost, createOne, deleteOne, queryList, queryOne, toUrlParamsForQuery, updateOne } from "../../shared/technical/rest/restApi";
import {Application} from "./Application";
import {handleErrorResponse, handleSuccessResponse} from "../../shared/technical/rest/errorHandling";
import { fullPageable, Pageable } from "../../shared/technical/rest/pageable";

export function getAllApplications(axios: AxiosInstance, pageable?: Pageable): Promise<Application[]> {
  const params = toUrlParamsForQuery(pageable ?? fullPageable(), undefined);
  return queryList(axios, 'applications', params)
}

export function getApplication(axios: AxiosInstance, idOrName: string | number): Promise<Application> {
  return queryOne(axios, 'applications', idOrName)
}

export function createApplication(axios: AxiosInstance, application: Application): Promise<Application> {
  return createOne(axios, 'applications', application)
}

export function updateApplication(axios: AxiosInstance, application: Application): Promise<Application> {
  return updateOne(axios, 'applications', application)
}

export function deleteApplication(axios: AxiosInstance, applicationId: string | number): Promise<void> {
  return deleteOne(axios, 'applications', applicationId)
}

export function syncApplicationUsers(axios: AxiosInstance, applicationId: string | number): Promise<void> {
  const baseUri = apiHost + '/applications/' + applicationId + '/user-sync';
  return axios.post(baseUri).then(handleSuccessResponse, handleErrorResponse);
}

export function getApplicationUserCount(axios: AxiosInstance, applicationId: string | number): Promise<Number> {
  const baseUri = apiHost + '/applications/' + applicationId + '/users/count';
  return axios.get(baseUri).then(handleSuccessResponse, handleErrorResponse);
}
